import { HotelConfig } from "stores/wizard/config";
import { DayName } from "uitk-react-date-picker";

export const hotelConfig: HotelConfig = {
  navigation: {
    tabIcon: "lob_hotels",
    tabTitleToken: "wizard.hotel.tab.title.label"
  },
  lastSearch: {
    lastSearchKey: "lastSearchCookie",
    lobKey: "wizard-flight-pwa"
  },
  location: {
    destination: {
      inputName: "",
      icon: "",
      invalidLocationMessageKey: "wizard.destination.warning.invalidDestination.text",
      labelToken: "",
      pwaDialogQueryParam: "destination-hotel",
      essAdapterConfig: {
        lob: "",
        client: "",
        features: "",
        maxResults: 7,
        regionType: 0
      }
    }
  },
  locationFlight: {
    origin: {
      inputName: "",
      icon: "",
      invalidLocationMessageKey: "",
      labelToken: "",
      pwaDialogQueryParam: "",
      essAdapterConfig: {
        lob: "",
        client: "",
        features: "",
        maxResults: 7,
        regionType: 0
      }
    }
  },
  date: {
    ISOSubmissionSupport: true,
    format: "yyyy-MM-dd",
    submissionFormat: "yyyy-MM-dd",
    firstDayOfWeek: DayName.SUN,
    daysBookableInAdvance: 500,
    midnightBookingOffset: 4,
    maxDaysRange: 28,
    invalidStartDateMessageToken: "wizard.datePicker.warning.invalidFromDate.text",
    invalidEndDateMessageToken: "wizard.datePicker.warning.invalidToDate.text",
    invalidMaxDatesRangeMessageToken: "wizard.datePicker.warning.maxDatesRange.text",
    invalidStartDateOutOfRangeMessageToken: "",
    invalidEndDateOutOfRangeMessageToken: "",
    start: {
      labelToken: "wizard.hotel.startDate.label"
    },
    end: {
      labelToken: "wizard.hotel.endDate.label"
    },
    queryParam: {
      start: "",
      end: ""
    },
    dialogId: "check-in-out"
  },
  form: {
    action: "",
    submitButton: {
      locToken: "wizard.submit.label"
    }
  },
  heading: {
    fixedTitle: false,
    mobileLocToken: "wizard.mobile.label.hotel"
  },
  elementId: "wizard-hotel-pwa",
  enableAddCar: false,
  enableAddFlight: false
};
